export const PayoutBankAccountVerificationStatus = {
  PENDING: 'pending',
  VERIFIED: 'verified',
  REJECTED: 'rejected',
} as const;

export type PayoutBankAccountVerificationStatus =
  (typeof PayoutBankAccountVerificationStatus)[keyof typeof PayoutBankAccountVerificationStatus];

export const PayoutBankAccountVerificationStatusValues = Object.values(PayoutBankAccountVerificationStatus);

export interface PayoutBankAccountDto {
  id: string;
  accountId: string;
  accountHolderName: string;
  iban: string;
  bic: string | null;
  isPrimary: boolean;
  verificationStatus: PayoutBankAccountVerificationStatus;
  rejectionReason: string | null;
  verifiedAt: string | null;
  verifiedByUserId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePayoutBankAccountDto {
  accountHolderName: string;
  iban: string;
  bic: string;
  /** If true and this is the first account, becomes primary. If multiple exist, default false unless only account. */
  isPrimary?: boolean;
}

export interface UpdatePayoutBankAccountDto {
  accountHolderName?: string;
  iban?: string;
  bic?: string;
}

export interface AdminPayoutBankAccountQueueItemDto {
  id: string;
  accountId: string;
  legalName: string;
  accountHolderName: string;
  ibanMasked: string;
  bic: string | null;
  isPrimary: boolean;
  createdAt: string;
}

export interface AdminReviewPayoutBankAccountDto {
  status: typeof PayoutBankAccountVerificationStatus.VERIFIED | typeof PayoutBankAccountVerificationStatus.REJECTED;
  rejectionReason?: string;
}
